module.exports = __webpack_public_path__ + "img/video-thumb-3-fr.e45f19df.png";